export class MemoSession {
  _session: any = { firstVisit: false }

  get firstVisit() {
    return this._session.firstVisit
  }

  get eventInstall() {
    return this._session.eventInstall
  }

  setSession(data: any) {
    this._session = { ...this._session, ...data }
  }
}
